import useSWR from "swr";
export function useCache(key: any, fetcher: any) {
  const { data, error, isLoading, mutate, isValidating } = useSWR(key, fetcher, { revalidateIfStale: true, revalidateOnFocus: true, revalidateOnReconnect: true, focusThrottleInterval: 5000 });

  return {
    mutate,
    data,
    isLoading,
    isValidating,
    isError: error,
  };
}
